module.exports = __webpack_public_path__ + "static/logo-cdda165ee9850992f85e8b32d36bd14c.png";